import React, { useCallback, useLayoutEffect, useRef } from "react";
import ResizeObserver from "resize-observer-polyfill";

// Polyfill for IE11
if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

const useResizeObserver = (
  element: React.RefObject<Element | null>,
  callback: (element: Element) => void
): void => {
  const resizeObserver = useRef<ResizeObserver>();

  const onResizeHandler: ResizeObserverCallback = useCallback(
    (entries) => callback(entries[0].target),
    [callback]
  );

  useLayoutEffect(() => {
    const divElement = element.current;

    if (divElement) {
      resizeObserver.current = new ResizeObserver(onResizeHandler);
      resizeObserver.current.observe(divElement);
    }

    return () => resizeObserver.current?.disconnect();
  }, [element, onResizeHandler]);
};

export default useResizeObserver;
